module.exports = __webpack_public_path__ + "img/55.ac6c60fd.jpg";